<div class="row" style="padding: 5px">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<!--Menu Bar-->
				<div class="lock-to-top" style="background-color: #ffffff">
					<!--Buttons-->
					<div class="button-body flex">
						<button [disabled]="Person == undefined || loading == true" class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">
							Refresh
						</button>

						<!--INSERT CUSTOM BUTTONS HERE-->
						<button
							[disabled]="Person == undefined || Person.PersonID == undefined || loading == true"
							class="btn btn-primary"
							style="margin-left: 5px"
							(click)="onAddAttendance()"
						>
							Add Attendance
						</button>
						<button
							[disabled]="Person == undefined || Person.PersonID == undefined || loading == true"
							class="btn btn-primary"
							style="margin-left: 5px"
							(click)="onEditAttendance()"
						>
							Edit Attendance
						</button>
						<button
							[disabled]="Person == undefined || Person.PersonID == undefined || loading == true"
							class="btn btn-primary"
							style="margin-left: 5px"
							(click)="onPrintAttendance()"
						>
							Print Attendance
						</button>
					</div>
				</div>

				<!--Table-->
				<div class="table-main-body">
					<p-table
						#mydt
						[value]="lstAttendance"
						[loading]="loading"
						[paginator]="true"
						[(rows)]="pagerows"
						[(first)]="pagefirst"
						[showCurrentPageReport]="true"
						[resizableColumns]="false"
						sortMode="multiple"
						styleClass="p-datatable-striped"
						selectionMode="single"
						[(selection)]="SelectedAttendance"
						dataKey="AttendanceID"
						(onFilter)="onHandleFilter($event)"
						(onSort)="onHandleSort($event)"
						(onRowSelect)="onRowSelect($event)"
						(onRowUnselect)="onRowUnselect($event)"
						currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
						[rowsPerPageOptions]="[5, 10, 25, 50]"
					>
						<!--Headers-->
						<ng-template pTemplate="header">
							<!--Filter or Select from Dropdown-->
							<tr>
								<!--INSERT CUSTOM FILTERS HERE-->

								<!--EntryDate-->
								<th>
									<!-- <p-columnFilter type="text" field="EntryDate" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
								</th>

								<!--EntryTime-->
								<th>
									<!-- <p-columnFilter type="text" field="EntryTime" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
								</th>

								<!--EntryDayDesc-->
								<th>
									<p-columnFilter field="EntryDayDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterEntryDayDesc
												[ngModel]="value"
												[options]="lstEntryDayDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--StatusDescription-->
								<th>
									<p-columnFilter field="StatusDescription" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterStatusDescription
												[ngModel]="value"
												[options]="lstStatusDescription"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--ExcuseDescription-->
								<th>
									<p-columnFilter field="ExcuseDescription" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterExcuseDescription
												[ngModel]="value"
												[options]="lstExcuseDescription"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--MethodDescription-->
								<th>
									<p-columnFilter field="MethodDescription" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterMethodDescription
												[ngModel]="value"
												[options]="lstMethodDescription"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--c_comment-->
								<th>
									<p-columnFilter type="text" field="c_comment" matchMode="contains" [showMenu]="true"></p-columnFilter>
								</th>
							</tr>

							<!--Column Names-->
							<tr style="height: 4rem">
								<!--INSERT CUSTOM COLUMNS HERE-->
								<th pSortableColumn="EntryDate">Date<p-sortIcon field="EntryDate"></p-sortIcon></th>
								<th pSortableColumn="EntryTime">Time<p-sortIcon field="EntryTime"></p-sortIcon></th>
								<th pSortableColumn="EntryDayDesc">Day<p-sortIcon field="EntryDayDesc"></p-sortIcon></th>
								<th pSortableColumn="StatusDescription">Status<p-sortIcon field="StatusDescription"></p-sortIcon></th>
								<th pSortableColumn="ExcuseDescription">Excuse/Reason<p-sortIcon field="ExcuseDescription"></p-sortIcon></th>
								<th pSortableColumn="MethodDescription">Entry Method<p-sortIcon field="MethodDescription"></p-sortIcon></th>
								<th pSortableColumn="c_comment">Comments<p-sortIcon field="c_comment"></p-sortIcon></th>
							</tr>
						</ng-template>

						<!--Data-->
						<ng-template pTemplate="body" let-Attendance>
							<tr [pSelectableRow]="Attendance" (dblclick)="onRowDblClick(Attendance)">
								<td *ngFor="let col of cols" style="font-weight: bold">
									{{ Attendance[col.field] }}
								</td>
							</tr>
						</ng-template>
					</p-table>
				</div>

				<!--Error Message-->
				<div class="TopMargin">
					<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
						{{ errorMessage }}
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
